export enum TransformationGroupScope {
  module = 'module',
  organization = 'organization'
}
